import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import Inputmask from 'inputmask';
import moment from 'moment';

/**
 * Класс-обёртка для работы с датой для фильтра (календарь)
 * требует загруженные плагины: DateRangePicker.js, Moment.js
 */
export class DatePickerComponent {
  /**
   * @param input {HTMLInputElement} - инпут, к которому привязывается календарь
   * @param params {Object} - настройки календаря
   */
  constructor(input, params = {}) {
    this.datePicker = input || null;
    this.$filterDate = $(input).parents('.js-birthday-date');

    this.init(params);
    this.initMask();
  }

  init(params) {
    if (!this.datePicker) return false;

    this.datePicker.daterangepicker(this.initOptions(params), this.cb.bind(this));

    this.initListeners();
    this.addYearButtons();
  }

  initOptions(params) {
    return {
      singleDatePicker: true,
      opens: params.opens || 'right',
      autoUpdateInput: false,
      autoApply: true,
      parentEl: this.$filterDate,
      locale: {
        format: 'YYYY-MM-DD',
        applyLabel: translator.t('main', 'Apply'),
        cancelLabel: translator.t('main', 'Reset'),
        daysOfWeek: [
          translator.t('date', 'Su'),
          translator.t('date', 'Mo'),
          translator.t('date', 'Tu'),
          translator.t('date', 'We'),
          translator.t('date', 'Th'),
          translator.t('date', 'Fr'),
          translator.t('date', 'Sa'),
        ],
        monthNames: [
          translator.t('date', 'January'),
          translator.t('date', 'February'),
          translator.t('date', 'March'),
          translator.t('date', 'April'),
          translator.t('date', 'May'),
          translator.t('date', 'June'),
          translator.t('date', 'July'),
          translator.t('date', 'August'),
          translator.t('date', 'September'),
          translator.t('date', 'October'),
          translator.t('date', 'November'),
          translator.t('date', 'December'),
        ],
        firstDay: 1,
      },
    };
  }

  addYearButtons() {
    setTimeout(() => {
      const $container = this.datePicker.data('daterangepicker')?.container;
      if ($container) {
        const $calendarHeader = $container.find('.drp-calendar.left thead tr:first');

        $calendarHeader.find('.year-nav').remove();

        const $monthHeader = $calendarHeader.find('th.month');
        if ($monthHeader.length) {
          $monthHeader.attr('colspan', 3);
        }

        const prevYearBtn = $('<th class="year-nav prev-year"><span></span></th>');
        const nextYearBtn = $('<th class="year-nav next-year"><span></span></th>');

        prevYearBtn.on('click', () => this.changeYear(-1));
        nextYearBtn.on('click', () => this.changeYear(1));

        $calendarHeader.prepend(prevYearBtn);
        $calendarHeader.append(nextYearBtn);

        this.observeMonthChange();
      }
    }, 10);
  }

  observeMonthChange() {
    const $container = this.datePicker.data('daterangepicker').container;

    $container.find('.drp-calendar .prev').off('click').on('click', () => {
      setTimeout(() => this.addYearButtons(), 50);
    });

    $container.find('.drp-calendar .next').off('click').on('click', () => {
      setTimeout(() => this.addYearButtons(), 50);
    });
  }

  changeYear(delta) {
    const datePickerInstance = this.datePicker.data('daterangepicker');
    const newDate = moment(datePickerInstance.startDate).add(delta, 'year');

    datePickerInstance.setStartDate(newDate);
    datePickerInstance.setEndDate(newDate);
    this.setVal(newDate.format('YYYY-MM-DD'));

    datePickerInstance.updateView();

    setTimeout(() => this.addYearButtons(), 50);
  }

  /**
   * Метод добавляющий обработчик на input или div в зависимости от типа устройства
   * на мобилке - обработчик на div
   * на десктопе - обработчик на input
   * Данный метод реализует открытие/закрытие календаря по нажатию на элемент
   */
  initListeners() {
    $(this.datePicker).on('apply.daterangepicker', (ev, picker) => {
      this.setVal(picker.startDate.format('YYYY-MM-DD'));
      this.$filterDate.addClass('selected');
    });

    $(this.datePicker).on('change.daterangepicker', (ev, picker) => {
      this.setVal(picker.startDate.format('YYYY-MM-DD'));
      this.$filterDate.addClass('selected');
    });

    $(this.datePicker).on('cancel.daterangepicker', () => {
      this.setVal('');
      this.$filterDate.removeClass('selected');
    });

    $(this.datePicker).on('show.daterangepicker', () => {
      this.addYearButtons();
    });
  }

  cb(start) {
    return this.setValByStartAndEnd(start.format('YYYY-MM-DD'));
  }

  setValByStartAndEnd(formatStart) {
    this.setVal(formatStart);
  }

  /**
   * Устанавливает подписчиков на событие
   * @param action {String}
   * @param fn {Function}
   */
  on(action, fn) {
    console.log('on action');
    if (action === 'apply') {
      this.datePicker.on('apply.daterangepicker', (ev, picker) => fn(ev, picker));
      this.datePicker.on('apply.daterangepicker', () => {
        $('.js-datepicker').removeClass('opened');
      });
    }

    if (action === 'change') {
      this.datePicker.on('change.daterangepicker', (ev, picker) => fn(ev, picker));
      this.datePicker.on('change.daterangepicker', () => {
        $('.js-datepicker').removeClass('opened');
      });
    }

    if (action === 'cancel') {
      this.datePicker.on('cancel.daterangepicker', (ev, picker) => fn(ev, picker));
      this.datePicker.on('cancel.daterangepicker', () => {
        $('.js-datepicker').removeClass('opened');
        $('.js-datepicker').removeClass('double');
      });
    }
  }

  formatCurrentDate() {
    const currentDate = new Date();

    let day = currentDate.getDate();
    day = day < 10 ? `0${day}` : day;

    let month = currentDate.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;

    const year = currentDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  clearDateRangeInputs() {
    return $('.js-date-range-input').prop('checked', false).removeClass('active');
  }

  setVal(val) {
    return this.datePicker.val(val);
  }

  setStartDate(date) {
    return this.datePicker.data('daterangepicker').setStartDate(date);
  }

  reset() {
    this.setVal(translator.t('main', 'Date'));
    this.setStartDate(new Date());
  }

  initMask() {
    if (this.datePicker) {
      Inputmask('9999-99-99', { placeholder: 'ГГГГ-ММ-ДД' }).mask(this.datePicker);
    }
  }
}
